"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("antd/es/comment/style/css");

var _comment = _interopRequireDefault(require("antd/es/comment"));

var _react = _interopRequireWildcard(require("react"));

var _moment = _interopRequireDefault(require("moment"));

require("./newQnaPostForm.scss");

var _icons = require("@ant-design/icons");

var _Username = _interopRequireDefault(require("../username/Username"));

var _QnaCommentList = _interopRequireDefault(require("./QnaCommentList"));

var _FlagActionItem = _interopRequireDefault(require("./FlagActionItem"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

class QnaComment extends _react.Component {
  constructor() {
    super(...arguments);

    this.renderDate = value => {
      if (!value) {
        return 'N/a';
      }

      return (0, _moment.default)(value).calendar();
    };
  }

  render() {
    const {
      comment,
      level
    } = this.props;
    const {
      id,
      participant,
      body,
      createDate,
      comments: childComments,
      thumbsups: commentThumbsups,
      favorites: commentFavorites,
      flags,
      isHidden
    } = comment;

    if (participant) {
      const {
        id: participantId,
        avatar,
        avatarBackground
      } = participant;
      const tags = [];

      if (isHidden) {
        tags.push( /*#__PURE__*/_react.default.createElement("span", {
          title: "hidden",
          className: "tag-bubble hidden"
        }, "HIDDEN"));
      }

      return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_comment.default, {
        style: level > 0 ? {
          marginLeft: `${level * 10 + 10}px`,
          backgroundColor: 'white'
        } : {
          backgroundColor: 'white'
        },
        className: "qna-post-comment",
        actions: [/*#__PURE__*/_react.default.createElement("span", {
          key: "list-vertical-message"
        }, /*#__PURE__*/_react.default.createElement(_icons.MessageOutlined, {
          style: {
            marginRight: 8
          }
        }), childComments ? childComments.length : 0), /*#__PURE__*/_react.default.createElement("span", {
          key: "list-vertical-like-o"
        }, /*#__PURE__*/_react.default.createElement(_icons.LikeOutlined, {
          style: {
            marginRight: 8
          }
        }), commentThumbsups ? commentThumbsups.length : 0), /*#__PURE__*/_react.default.createElement("span", {
          key: "list-vertical-star-o"
        }, /*#__PURE__*/_react.default.createElement(_icons.StarOutlined, {
          style: {
            marginRight: 8
          }
        }), commentFavorites ? commentFavorites.length : 0), /*#__PURE__*/_react.default.createElement(_FlagActionItem.default, {
          participantId: participantId,
          id: id,
          isHidden: isHidden,
          type: "comment",
          flags: flags
        })],
        author: /*#__PURE__*/_react.default.createElement("span", null, /*#__PURE__*/_react.default.createElement(_Username.default, {
          participantId: participantId,
          style: {
            color: '#8185B3'
          }
        }), tags),
        avatar: /*#__PURE__*/_react.default.createElement("img", {
          className: "qna-avatar",
          alt: "avatar",
          src: `${avatar ? avatar.avatar : ''}`,
          style: {
            backgroundColor: avatarBackground ? `#${avatarBackground}` : '#FFB100'
          }
        }),
        content: /*#__PURE__*/_react.default.createElement("p", null, body),
        datetime: (0, _moment.default)(createDate).calendar()
      }), childComments && childComments.length > 0 && /*#__PURE__*/_react.default.createElement(_QnaCommentList.default, {
        level: level + 1,
        comments: childComments
      }));
    }

    return /*#__PURE__*/_react.default.createElement("div", null);
  }

}

var _default = QnaComment;
exports.default = _default;